import type { DemoKey } from './keys';

export const vi: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Hình học · 3D',
  'panel.figure': 'Hình',
  'panel.dims': 'Kích thước',
  'panel.style': 'Giao diện',
  'panel.lines': 'Đường đặc biệt',
  'style.body': 'Thân',
  'style.line': 'Đường',
  'style.cut': 'Mặt cắt',
  'style.labels': 'Nhãn đỉnh',
  'group.face': 'Đường chéo mặt / đường sinh',
  'group.space': 'Đường chéo / trục / trung tuyến',
  'split.label': 'Mặt cắt',
  'btn.animate': 'Hoạt hình',
  'btn.reset': 'Đặt lại',
  'hint.line1': 'Kéo để xoay · Cuộn để phóng to',
  'hint.line2': 'Nhấp vào đường để chọn',
  'fig.cuboid': 'Hình hộp chữ nhật',
  'fig.cube': 'Hình lập phương',
  'fig.triPrism': 'Lăng trụ tam giác',
  'fig.hexPrism': 'Lăng trụ lục giác',
  'fig.tetrahedron': 'Tứ diện',
  'fig.squarePyramid': 'Hình chóp tứ giác',
  'fig.cylinder': 'Hình trụ',
  'fig.cone': 'Hình nón',
  'fig.sphere': 'Hình cầu',
  'fig.frustumPyramid': 'Chóp cụt',
  'fig.frustumCone': 'Nón cụt',
  'dim.length': 'chiều dài',
  'dim.width': 'chiều rộng',
  'dim.height': 'chiều cao',
  'dim.side': 'cạnh',
  'dim.radius': 'bán kính',
  'dim.r1': 'bán kính dưới',
  'dim.r2': 'bán kính trên',
  'dim.sideBase': 'cạnh đáy',
  'dim.sideTop': 'cạnh trên',
  'info.face': 'mặt',
  'info.center': 'qua tâm',
  'info.diagonal': 'đường chéo',
  'info.axial': 'đường chéo trục',
  'info.diameter': 'đường kính',
  'info.generator': 'đường sinh',
  'info.axis': 'trục',
  'info.height': 'chiều cao',
  'info.median': 'trung tuyến',
  'info.apothem': 'trung đoạn',
  'info.diameterBase': 'đường kính đáy',
  'info.diameterTop': 'đường kính trên',
};
